/* ------------------------------------------------------------
 * Created By	: CodeBhagat v2.0
 * Created Date	: 12/27/2016
 * Component	: QuarterlyOrdersModule
 * Purpose		: Module for QuarterlyOrders.
 * Copyright	: Copyright 2014-2016 CodeBhagat LLC. All Rights Reserved.
 * Restrictions	: The generated code is for evaluation purpose only. Use of this generated code requires valid softare license.
 * ------------------------------------------------------------
*/

import { NgModule }       from '@angular/core';
import { CommonModule }   from '@angular/common';
import { FormsModule }    from '@angular/forms';
import { SharedModule } from '../shared/Shared.module';

import { QuarterlyOrdersService } from './QuarterlyOrders.service';
import { QuarterlyOrdersListComponent } from './QuarterlyOrdersList.component';
import { QuarterlyOrdersSearchComponent } from './QuarterlyOrdersSearch.component';
import { QuarterlyOrdersDetailsComponent } from './QuarterlyOrdersDetails.component';

import { QuarterlyOrdersRoutingModule } from './QuarterlyOrders-routing.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
	SharedModule,
    QuarterlyOrdersRoutingModule
  ],
  declarations: [
    QuarterlyOrdersListComponent,
	QuarterlyOrdersSearchComponent,
	QuarterlyOrdersDetailsComponent
  ],
  providers: [
    QuarterlyOrdersService
  ]
})

export class QuarterlyOrdersModule { }



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/QuarterlyOrders/QuarterlyOrders.module.ts